import { arrayMove } from '@dnd-kit/sortable';

export const getSortableRowId = (
    row: { rowId?: string },
    fallback: string,
): string => String(row.rowId || fallback);

export const reorderItemsById = <T,>(
    items: T[],
    activeId: string | number,
    overId: string | number,
    getId: (item: T, index: number) => string,
): T[] => {
    const oldIndex = items.findIndex((item, index) => getId(item, index) === String(activeId));
    const newIndex = items.findIndex((item, index) => getId(item, index) === String(overId));
    if (oldIndex < 0 || newIndex < 0 || oldIndex === newIndex) return items;
    return arrayMove(items, oldIndex, newIndex);
};
